// client/src/routes/app/audit-log.tsx — SCR-AUD-001 · AUD-002 (04 §8.17).
//
// Replaces UI-003's `PlaceholderScreen`, which named this item as its owner.
//
// The route owns the URL state and nothing else: `validateSearch` runs the §9.2.3 schema and
// the screen reads it back typed, so a filtered journal is shareable, survives refresh, and
// Back is a filter-undo. That matters more here than on any other list — „găsește-mi
// confirmarea fiscală de marți" ends in a link somebody sends to somebody else.
//
// `Audit.Read` is UI-003's guard and stays: the sidebar hides the entry, and this renders
// SCR-SYS-403 for the URL that was typed anyway (§9.2.2). 03 §17.1 grants the permission to
// `owner` and `accountant` and withholds it from `manager` — the journal is the one read
// surface a manager does not have, and that is deliberate (02 §18.4). A platform `admin` holds
// no org-scoped permission at all, so the „admin sees platform events" half of §8.17 is not
// this screen and not this milestone's (D-1414 records where it went).
//
// There is no write gate to mirror, because the trail is append-only at the database level
// (`AuditLogSchemaSql`) and this screen offers no verb but „descarcă".

import { createFileRoute, useNavigate } from '@tanstack/react-router';

import { RequirePermission } from '@/components/layout/route-guards';
import { AuditJournal } from '@/features/audit/AuditJournal';
import { auditSearchSchema, type AuditSearch } from '@/features/audit/search';

export const Route = createFileRoute('/app/audit-log')({
  validateSearch: auditSearchSchema,
  component: AuditLogScreen,
});

function AuditLogScreen() {
  const search = Route.useSearch();
  const navigate = useNavigate({ from: Route.fullPath });

  return (
    <RequirePermission permission="Audit.Read">
      <AuditJournal
        search={search}
        onSearchChange={(next: (previous: AuditSearch) => AuditSearch) => {
          void navigate({ search: next });
        }}
      />
    </RequirePermission>
  );
}
